/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';
import env from './env';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: env().SSO_AZURE_CLIENT_ID,
    authority: env().SSO_AZURE_AUTHORITY,
    redirectUri: env().SSO_AZURE_REDIRECT_URL,
  },
  cache: {
    cacheLocation: env().SSO_AZURE_CACHE_LOCATION, // This configures where your cache will be stored
    storeAuthStateInCookie: env().SSO_AZURE_STORE_AUTH_STATE_IN_COOKIE, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        if (env().NODE_ENV === 'dev') {
          if (level === LogLevel.Error) {
            console.error(message);
            return;
          } else if (level === LogLevel.Info) {
            console.info(message);
            return;
          } else if (level === LogLevel.Verbose) {
            console.debug(message);
            return;
          } else if (level === LogLevel.Warning) {
            console.warn(message);
            return;
          }
        }
      },
    },
  },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
  scopes: ['User.Read'],
};

/**
 * Add here the scopes to request when obtaining an access token for MS Graph API. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
